module.exports = __webpack_public_path__ + "image/pro_article_img2.jpg";